import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfig, useTheme } from '@connor-music/shared';
import { LogOut } from 'lucide-react';

export default function Logout() {
  const { config } = useConfig();
  const { resolvedTheme } = useTheme();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);

  const logoUrl = resolvedTheme === 'dark' ? config.logo_dark_url : config.logo_light_url;

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/login', { replace: true });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 px-4 py-8 sm:py-12">
      <div className="w-full max-w-sm sm:max-w-md">
        <div className="rounded-xl border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-800 px-6 py-8 sm:px-10 sm:py-10">
          <div className="text-center">
            {logoUrl ? (
              <div className="mb-6 flex justify-center">
                <img
                  src={logoUrl}
                  alt={config.portal_name || 'Connor Music Audit'}
                  style={{ width: config.login_logo_width || 200 }}
                  className="h-auto"
                />
              </div>
            ) : (
              <div className="mb-6 flex justify-center">
                <div className="flex h-14 w-14 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700">
                  <LogOut className="h-7 w-7 text-gray-500 dark:text-gray-400" />
                </div>
              </div>
            )}

            <h1 className="text-2xl font-bold text-gray-900 dark:text-white sm:text-3xl">
              You've been signed out
            </h1>
            <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
              Your session has ended securely.
            </p>

            {/* Divider */}
            <div className="my-6 border-t border-gray-200 dark:border-gray-700" />

            {/* Countdown */}
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Redirecting to sign in{countdown > 0 ? ` in ${countdown}s` : ''}...
            </p>

            {/* Progress bar */}
            <div className="mt-4 h-1 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700">
              <div
                className="h-full rounded-full bg-accent-500 transition-all duration-1000 ease-linear"
                style={{ width: `${((3 - countdown) / 3) * 100}%` }}
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 flex flex-col items-center gap-2 text-xs text-gray-400 dark:text-gray-500">
          <p>&copy; {new Date().getFullYear()} Connor Consulting Corporation</p>
        </div>
      </div>
    </div>
  );
}
